module.exports = __webpack_public_path__ + "img/privacy-mode-icon.b627e142.png";